import PnaDetails from "../Components/Pna/PnaDetails";
import PnaHoldings from "../Components/Pna/PnaHoldings";
import Subscriptions from "../Components/Pna/Subscriptions";
import ActivityLog from "../Components/Pna/ActivityLog";
import { useGet } from "../Hooks/useFetch";
import { useState, useEffect } from "react";

const Home = () => {
    
    const [pnaResponse, pnaError, pnaLoading, apiGetPna] = useGet();
    const [holdingsResponse, holdingsError, holdingsLoading, apiGetHoldings] = useGet();
    const [activityResponse, activityError, activityLoading, apiGetActivity] = useGet();
    
    const [allDataLoaded, setAllDataLoaded] = useState(false);

    // Load all data on component mount
    useEffect(() => {
        const loadAllData = async () => {
            try {
                // DMZ-only stored procedure calls via API endpoints
                await Promise.all([
                    apiGetPna('/api/pna/PnaDecryptedData'),
                    apiGetHoldings('/api/pna/PnaHoldings'),
                    apiGetActivity('/api/pna/Activity-log')
                ]);
            } catch (error) {
                console.error('Error loading home data:', error);
            }
        };

        loadAllData();
    }, []);

    // Check if all data is loaded
    useEffect(() => {
        const isAllLoaded = !pnaLoading && !holdingsLoading && !activityLoading;
        if (isAllLoaded) {
            setAllDataLoaded(true);
        }
    }, [pnaLoading, holdingsLoading, activityLoading]);
    return (
        <>
            <div className="home-container">
                <div className="row">
                    <div className="col-md-8">
                        <PnaDetails res={pnaResponse} error={pnaError} isLoading={!allDataLoaded}/>
                        <Subscriptions/> 
                        <ActivityLog res={activityResponse} error={activityError} isLoading={!allDataLoaded}/>
                    </div>
                    <div className="col-md-4">
                        <PnaHoldings res={holdingsResponse} error={holdingsError} isLoading={!allDataLoaded}/>
                    </div>
                </div>
                
            </div>
        </>
    );
};

export default Home;